import ZoneHeadApartmentList from '../../features/zoneHead/ZoneHeadApartmentList'

const ZoneHeadApartmentListPage = () => {
    return <ZoneHeadApartmentList/>
}

export default ZoneHeadApartmentListPage